const sendMessage = async (message) => {
  const response = await fetch(`https://api.twitch.tv/helix/chat/messages`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer 0kwphob1yf0kpuzblklezat14kwblk`,
      "Client-Id": `gp762nuuoqcoxypju8c569th9wz7q5`,
    },
    body: JSON.stringify({
      broadcaster_id: "52621384",
      sender_id: "1102968448",
      message: message,
    }),
  });

  if (!response.ok) {
    throw new Error("Error sending message");
  }
};

export default sendMessage;
